export const CUSTOMER_CODE = 'C8841938';
export const LTL_TRANSPORT_MODES = [
  {
    mode: 'LTL',
    equipments: [
      {
        equipmentType: 'Van',
        quantity: 1,
      },
    ],
  },
];

export const TL_TRANSPORT_MODES = [
  {
    mode: 'TL',
    equipments: [
      {
        equipmentType: 'Van',
        quantity: 1,
      },
    ],
  },
];

export const VIEW_BID_LENGTH = {
  LEN_0: 0,
  LEN_1: 1,
};

export const LISTING_DETAILS_MESSAGES = {
  inventory_prepped: [
    {
      id: 'pre-sorted',
      value: 'These items have been scanned or sorted for online sales or other channels.',
    },
    {
      id: 'not-sorted',
      value: 'These items have not been scanned or sorted for online sales or other channels.',
    },
  ],
  grading_status: [
    {
      id: 'graded',
      value: 'These items have been graded to separate out heavily damaged ones.',
    },
    {
      id: 'not_graded',
      value: 'These items have not been graded to separate out heavily damaged ones.',
    },
  ],
  listing_pricing: [
    {
      id: 'one_week_auction',
      value: 'These items are listed for a one-week auction.',
    },
    {
      id: 'blind_auction',
      value: 'These items are listed for blind auction.',
    },
    {
      id: 'fixed_price',
      value: 'These items have a fixed price.',
    },
    {
      id: 'other',
      value: 'These items have a different pricing strategy.',
    },
  ],
};
